var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { label: "経験職種・希望職種", "has-child": "" } },
    [
      _c("div", { staticClass: "boss-table-2-layout" }, [
        _c(
          "div",
          {
            staticClass: "boss-table-2-item boss-table-2-item-body",
            class: {
              "is-modified":
                _vm.desiredOccupations.length ||
                _vm.experiencedOccupations.length,
            },
          },
          [
            _c("div", { staticClass: "boss-separated-small" }, [
              _c(
                "div",
                {
                  staticClass:
                    "boss-layout boss-layout-start boss-layout-gap-large",
                },
                _vm._l(_vm.options, function (option, i) {
                  return _c(
                    "label",
                    {
                      key: i,
                      staticClass: "pega-input",
                      attrs: { "data-test": "label-" + i },
                    },
                    [
                      _c("input", {
                        staticClass: "boss-input-checkbox",
                        attrs: { "data-test": "radio-" + i, type: "radio" },
                        domProps: {
                          checked: _vm.selectedOption === option.key,
                          value: option.key,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit(
                              "update:selectedOption",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(_vm._s(option.label) + "\n          "),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "boss-table-2-layout",
          attrs: { "data-test": "experienced-occupation" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact",
            },
            [_vm._v("\n      経験職種\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "boss-table-2-item boss-table-2-item-body",
              class: { "is-modified": _vm.experiencedOccupations.length },
              attrs: { "data-test": "experienced-occupation-body" },
            },
            [
              _vm.occupationsMaster.length > 0
                ? _c("select-modal-button", {
                    attrs: {
                      "master-data": _vm.occupationsMaster,
                      "selected-items": _vm.experiencedOccupations.map(
                        function (o) {
                          return { id: o, experience: "" }
                        }
                      ),
                      title: "職種",
                      suffix: "experienced-occupations",
                      "data-test": "experienced-occupation-modal",
                    },
                    on: {
                      "update-modal-checked-ids": function (value) {
                        return _vm.$emit(
                          "update:experiencedOccupations",
                          value.map(function (o) {
                            return o.id
                          })
                        )
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "boss-table-2-layout",
          attrs: { "data-test": "desired-occupation" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact",
            },
            [_vm._v("\n      希望職種\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "boss-table-2-item boss-table-2-item-body",
              class: { "is-modified": _vm.desiredOccupations.length },
              attrs: { "data-test": "desired-occupation-body" },
            },
            [
              _c("label", { staticClass: "boss-checkbox" }, [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: { type: "checkbox", "data-test": "check-box" },
                  domProps: { checked: _vm.containOccupationsNonHopeUser },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "update:containOccupationsNonHopeUser",
                        $event.target.checked
                      )
                    },
                  },
                }),
                _vm._v(
                  "選択した希望職種を「どちらでもない・未入力」としている会員を含む\n      "
                ),
              ]),
              _vm._v(" "),
              _vm.occupationsMaster.length > 0
                ? _c("select-modal-button", {
                    attrs: {
                      "master-data": _vm.occupationsMaster,
                      "selected-items": _vm.desiredOccupations.map(function (
                        o
                      ) {
                        return { id: o, experience: "" }
                      }),
                      title: "職種",
                      suffix: "desired-occupations",
                      "data-test": "desired-occupation-modal",
                    },
                    on: {
                      "update-modal-checked-ids": function (value) {
                        return _vm.$emit(
                          "update:desiredOccupations",
                          value.map(function (o) {
                            return o.id
                          })
                        )
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }